module.exports = __webpack_public_path__ + "img/circle4blue.b5e3f5ae.png";